import BaseDataTableController from "./base_datatable_controller";

// Types where the events are not modifiable when guests respond to an invitation
const DISALLOWED_GUEST_TYPES = ["supervisor"];

export default class extends BaseDataTableController {
  static targets = [
    "events",
    "emailSelectionButton",
    "emailSelectionSpinner",
    "selectedEmailFields",
  ];

  declare readonly emailSelectionButtonTarget: HTMLButtonElement;
  declare readonly hasEmailSelectionButtonTarget: boolean;
  declare readonly emailSelectionSpinnerTarget: HTMLElement;
  declare readonly hasEmailSelectionSpinnerTarget: boolean;
  declare readonly eventsTarget: HTMLInputElement;
  declare readonly hasEventsTarget: boolean;
  declare readonly selectedEmailFieldsTarget: HTMLElement;
  declare readonly hasSelectedEmailFieldsTarget: boolean;
  #submittingSelectedEmails = false;

  connect() {
    console.debug("Connected to Guest Controller");
    this.toggleEvents();
    this.#setupGuestTable();
    this.syncEmailSelectionControls();
    window.addEventListener("focus", this.resetEmailSubmitState);
  }

  disconnect() {
    window.removeEventListener("focus", this.resetEmailSubmitState);
  }

  toggleEvents() {
    if (!this.hasEventsTarget) return;

    const selected = this.element.querySelector<HTMLSelectElement>(
      'select[name="guest[attending_as]"]',
    );
    if (selected && DISALLOWED_GUEST_TYPES.includes(selected.value)) {
      this.eventsTarget.style.display = "block";
    } else {
      this.eventsTarget.style.display = "none";
    }
  }

  toggleAllEmailSelections(event: Event) {
    this.toggleAllSelections(event);
    this.syncEmailSelectionControls();
  }

  syncEmailSelectionControls() {
    super.syncSelectionControls();

    if (this.hasEmailSelectionButtonTarget) {
      this.emailSelectionButtonTarget.disabled =
        this.#submittingSelectedEmails ||
        this.emailSelectionButtonTarget.dataset.emailEnabled !== "true" ||
        !this.selectionAllowed();
    }

    if (this.hasEmailSelectionSpinnerTarget) {
      this.emailSelectionSpinnerTarget.classList.toggle(
        "d-none",
        !this.#submittingSelectedEmails,
      );
    }
  }

  submitSelectedEmails(event: Event) {
    if (this.#submittingSelectedEmails || !this.selectionAllowed()) {
      event.preventDefault();
      return;
    }

    if (!this.hasSelectedEmailFieldsTarget) return;

    this.#submittingSelectedEmails = true;
    this.appendSelectedValues(this.selectedEmailFieldsTarget, "guest_ids[]");
    this.syncEmailSelectionControls();
  }

  resetEmailSubmitState = () => {
    this.#submittingSelectedEmails = false;
    this.syncEmailSelectionControls();
  };

  #setupGuestTable() {
    if (!this.element.querySelector("#datatable")) return;

    super.setupSelectableTable(undefined, {
      checkboxSelector: 'input[name="guest_ids[]"]',
      allowEmptySelection: false,
    });
    this.table?.on("draw", () => this.syncEmailSelectionControls());
  }
}
